import ajax from '../../lib/ajax';
import warehouseCity from '../entities/warehouse-city'
const warehouseCityModule = {
    namespaced: true,
    state: {

    },
    actions: {
        async get(state: any, payload: any) {
            let rep = await ajax.get('/api/services/app/WarehouseCity/GetWarehouseCity');
            return rep.data.result as Array<warehouseCity>;
        },
    }
}
export default warehouseCityModule;